import React from 'react';
import TyreFilters from './TyreFilters';
import '../scss/TyreFilters.scss';

const SearchWidget = () => {
  const handleFilterChange = (filters) => {
    // Store filters to be used later
    console.log('Filters changed:', filters);
  };

  const handleSearch = (filters) => {
    // Redirect to the catalog page with the filter parameters
    const searchParams = new URLSearchParams();
    
    // Add each filter to the URL parameters
    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        searchParams.append(key, value);
      }
    });
    
    // Get the favorite store URL from the global variable
    const favoriteStoreUrl = window.axTyresCatalog?.favoriteStoreUrl || '';
    
    // Build the catalog URL
    let catalogUrl = favoriteStoreUrl 
      ? `${favoriteStoreUrl.replace(/\/?$/, '/')}/catalogue-pneus/` 
      : '/catalogue-pneus/';
    
    // Remove any double slashes except after http(s):
    catalogUrl = catalogUrl.replace(/([^:]\/)\/+/g, "$1");
    
    // Redirect to the catalog page with the search parameters
    window.location.href = `${catalogUrl}?${searchParams.toString()}`;
  };

  return (
    <div className="search-widget">
      <TyreFilters 
        onFilterChange={handleFilterChange} 
        onSearch={handleSearch} 
        isWidget={true}
      />
    </div>
  );
};

export default SearchWidget; 